import type { LevelCatalog, PurchaseService } from "@highmarch/app";
import type { HubApi } from "../../features/registry";

/**
 * How the hub pages the economy touches reach it (FINISH_PLAN WP5) without new constructor arguments on files that
 * are frozen this wave (hubView.ts builds the Towers tab and the upgrade sheet; the Armoury builds its item card):
 * the economy feature (features/economy.ts) sets the link once at boot, and its hub widget records the hub while it
 * is up. A page asks `economyLink()`; null in tests and before boot, when the page simply leaves its economy parts out.
 */
export interface EconomyLink {
  readonly catalog: LevelCatalog;
  now(): number;
  /** Stores the save (no hub redraw). */
  persist(): void;
  /** Real-money gem packs; null when no store could be opened. */
  readonly purchases: PurchaseService | null;
  /** The store behind `purchases` (the web's sandbox or StoreKit 2). */
  readonly storeKind: "sandbox" | "storekit2" | null;
  /** The hub's services while the hub is up (null in a level). */
  hub: HubApi | null;
}

let link: EconomyLink | null = null;

export function setEconomyLink(l: EconomyLink | null): void { link = l; }
export function economyLink(): EconomyLink | null { return link; }

/** State changed from a hub page: save and redraw the hub (its pills), or just save when the hub is not up. */
export function economyChanged(): void {
  if (!link) return;
  if (link.hub) link.hub.changed(); else link.persist();
}
